import { assertNever } from '@gonfalon/types/assertNever';
import type { IconName } from '@launchpad-ui/icons';

import type { Command } from '../types/command';

/**
 * Default icon for a command by type. Used when the command itself
 * doesn't carry an explicit `icon` field.
 *
 * Returning a strict per-type icon (not falling through to a generic
 * `circle`) makes the listbox more scannable: users learn at a glance
 * "lightning bolt = invokes something", "link = navigates",
 * "expand = opens a view". The exhaustiveness check catches new
 * command types added to the union at compile time.
 */
export function getTypeIcon(type: Command['type']): IconName {
  switch (type) {
    case 'action':
      return 'bolt';
    case 'link':
      return 'link';
    case 'view':
      // No purpose-built "view" icon in the launchpad-ui set; `stack`
      // reads roughly as "a sub-surface lives behind this" without
      // overcommitting to a metaphor. Swap when a better candidate
      // lands in the icon library.
      return 'stack';
    default:
      return assertNever(type);
  }
}
